<div class="outer-content">
  <div class="float-left bg-white card-background wh-auto">

    <form [formGroup]="lifestyleForm" autocomplete="off" role="form" class="fieldHeight">
      <div *ngIf="componentRefOfControlType">
        <app-content-top-nav [emitInvalidEvtFlag]="true" [cdRefParent]="componentRefOfControlType.instance.cdRef" [parentElement]="el" [parentFormToValidate]="componentRefOfControlType.instance.parentForm"
          [parentFormToJustToClear]="lifestyleFormForRisk" [visibleSaveProgress]="!isHOView" [enableBackNav]='!editMode' [visibleBackNav]="backButtonEnabled" (onBackClickHandler)="OnBackClick()"></app-content-top-nav>
      </div>
      <div class="col-md-12 clear-all title-wrapper">
        <h1 class="title-text custom-header-h2 responsive-text-8" id="healthAndLifeStyle-header">{{healthData.header}}</h1>
      </div>
      <div class="col-md-12 clear-all content-wrapper">
        <div class="col-md-12 clear-all">
          <div [ngClass]="utilityServiceForMedicalService.currentUWScreenName === 'dependant'? 
            'col-md-12 clear-all to-give-you-the-best-dep': 'col-md-12 clear-all to-give-you-the-best'">
              <span id="healthAndLifeStyle-helpText" [innerHTML]="healthData.healthDescriptionText"></span>
              <div [ngClass]="utilityServiceForMedicalService.currentUWScreenName === 'dependant' ? 'info-dependant' : 'info-for-para-text'">
                <app-tool-tip-notification (lifestyleHealthRiskInfoEmitter)="lifestyleHealthRiskInfoEmitter($event)" [childId]="'healthandlifestyleinfo'" [tooltipData]="lifestyleConfig" (onDisplayMobileTooltipEmitter)="displayTooltipMessage()">
                </app-tool-tip-notification>
              </div>
            </div>
        </div>
        <div class="col-md-12 privacy-container">
          <span id="healthAndLifeStyle-policyText" class="If-you-would-like-to text-style-1" [innerHTML]="healthData.privacyPolicyText"></span>
          <a target="_blank" (click)="lifestylePrivacyInfo()" href="https://www.legalandgeneral.com/privacy-policy/">
            <span id="healthAndLifeStyle-clickHere" class="If-you-would-like-to-click">{{healthData.clickHereText}}</span>
          </a>
        </div>

        <ng-container *ngIf="utilityServiceForMedicalService.currentUWScreenName === 'annuitant' && !isHOView && lifestyleFormForRisk">
          <div >
            <app-question [childId]="'lifestyleRiskWarningQuestion'" [questionConfig]="healthData.yourLifestyleConfig" [parent]="lifestyleFormForRisk"
              [controlName]="'lifestyleRiskWarningQuestion'">
            </app-question>
          </div>
        </ng-container>

        <div class="col-md-12 underline margin-top margin-bottom"></div>
        <div class="col-md-12 clear-all margin-top-10">
          <span role="heading" aria-level="3" class="your-health">{{healthData.yourHealthLabel}}</span>
        </div>
        <div class="col-md-12 clear-all">
          <ng-template mandatory-questions-dir></ng-template>
        </div>

      </div>
      <div class="col-md-12 underline margin-top margin-bottom"></div>
      <!-- My section 1 & 2 starts -->


      <div class="col-md-12 clear-all bottom-container">
        <div *ngIf="componentRefOfControlType">
          <div class="float-left" *ngIf="!isHOView">
            <app-save [emitInvalidEvtFlag]="true" [cdRefParent]="componentRefOfControlType.instance.cdRef" 
            [parentFormToJustToClear]="lifestyleFormForRisk" [parentElement]="el" [parentFormToValidate]="componentRefOfControlType.instance.parentForm" [location]="'contentBottom'"></app-save>
          </div>
        </div>
        <div class="float-right">
          <app-content-bottom-nav (onNextHandler)="gotoNextPage()" *ngIf="!loadSpinner" [userInputDetail]="userInputDetail['buttonConfig']"
            [buttonType]="'normalCTA'">
          </app-content-bottom-nav>
          <button *ngIf="loadSpinner" class="btn btn-cta btn-loading btn-opacity " type="button">
            <span class="btn-text">Primary button</span>
            <div class="spinner spinner-white">
              <div class="spinner-ring" aria-hidden="true"></div>
              <span class="access">Loading...</span>
            </div>
          </button>
        </div>
      </div>

    </form>
  </div>
  <app-modal *ngIf="displayTooltipAlert" [modalConfig]="tooltipModalConfig" (closeModal)="closeModal()"
  (primaryBtnClick)="alertTooltipPrimaryBtnClick()" (secondaryBtnClick)="alertSecondaryBtnClick()" [tooltipFlag]="true"></app-modal>
</div>